// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"9442c416","239":"bb1e2b45","455":"efde2c69"}[chunkId] + ".chunk.js";
};